import { AssetState, Asset } from '../types/asset';
import { DEFAULT_FILE_TYPES } from '../config';

export const ASSET_STATES: AssetState[] = [
  AssetState.INITIAL,
  AssetState.IDENTIFIED,
  AssetState.REGISTERED,
  AssetState.INGESTED,
  AssetState.ERROR
];

const BUCKETS = ['harbour-inbox', 'axetay-ingestion', 'data-harbour-prod'];

function generateRandomHash() {
  return Math.random().toString(16).substring(2, 10) + Math.random().toString(16).substring(2, 10);
}

function generateEvents(state: AssetState, receivedOn: number): { state: AssetState; date: number; description: string }[] {
  const events: { state: AssetState; date: number; description: string }[] = [
    { state: AssetState.INITIAL, date: receivedOn, description: 'Asset received from S3' }
  ];

  if (state !== AssetState.INITIAL) {
    events.push({
      state: AssetState.IDENTIFIED,
      date: receivedOn + 120000,
      description: 'File type identified'
    });
  }

  if (state === AssetState.REGISTERED || state === AssetState.INGESTED) {
    events.push({
      state: AssetState.REGISTERED,
      date: receivedOn + 180000,
      description: 'Asset copied to staging bucket'
    });
  }

  if (state === AssetState.INGESTED) {
    events.push({
      state: AssetState.INGESTED,
      date: receivedOn + 300000,
      description: 'Final ingestion complete'
    });
  }

  if (state === AssetState.ERROR) {
    events.push({
      state: AssetState.ERROR,
      date: receivedOn + 150000,
      description: 'Critical: Failed to extract metadata or identify file schema.'
    });
  }

  return events.reverse();
}

export const generateMockAssets = (count: number): Asset[] => {
  const fileTypes = DEFAULT_FILE_TYPES;
  return Array.from({ length: count }).map((_, i) => {
    const id = generateRandomHash();
    const type = fileTypes[Math.floor(Math.random() * fileTypes.length)];
    const state = ASSET_STATES[Math.floor(Math.random() * (ASSET_STATES.length - 1))];
    const bucket = BUCKETS[Math.floor(Math.random() * BUCKETS.length)];
    const receivedOn = Date.now() - Math.floor(Math.random() * 1000 * 60 * 60 * 24 * 7);
    const fileName = `${type.toLowerCase()}_${i}.csv`;
    const path = `ingestion/${type.toLowerCase()}/${fileName}`;

    return {
      id,
      assetId: id,
      sourceUri: `s3://${bucket}/${path}`,
      fileType: type,
      state,
      storageType: 'S3' as const,
      size: Math.floor(Math.random() * 50000000),
      receivedOn,
      locationAddress: bucket,
      locationPath: path,
      stagedCopy: state === AssetState.REGISTERED ? `s3://harbour-staging/${id}.csv` : undefined,
      stagedCopyKey: state === AssetState.REGISTERED ? `${id}.csv` : undefined,
      events: generateEvents(state, receivedOn)
    };
  });
};
